import activationGrowlib from './activationGrowlib.vue'

export default activationGrowlib
